/**
 * Shared initials-avatar helpers (#776) — the single source for the initials
 * fallback previously duplicated across ConsultantTable, ConsultantCard,
 * ConsultantProfile and SkillConsultantsPopover.
 *
 * Semantics follow the table/card originals: first + LAST word, uppercased
 * (the logged-in-user helper in `lib/auth.ts` uses first + second word — they
 * only diverge for 3+-word names, and that helper stays canonical for the
 * user menu).
 */

const AVATAR_COLORS = [
  "bg-blue-500",
  "bg-green-500",
  "bg-purple-500",
  "bg-orange-500",
  "bg-pink-500",
  "bg-teal-500",
  "bg-indigo-500",
  "bg-red-500",
];

export const getAvatarColor = (name: string): string => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

export const getInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
